import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

// Not filtering GenderIdentityChoices for restrictive countries since the entire is hidden in that case

const GenderIdentityChoices = [
  { label: l`global.man`, id: "MAN" },
  { label: l`global.woman`, id: "WOMAN" },
  { label: l`global.nonBinary`, id: "NON_BINARY" },
  { label: l`global.anotherGenderIdentity`, id: "ANOTHER_GENDER_IDENTITY" }
]

export default GenderIdentityChoices
